import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-style-guide';
import { DeviceMeta } from 'Roblox';
import GetPremiumButton from './GetPremiumButton';

const { isInApp } = DeviceMeta();

function TitleAnchor({ translate, isShown }) {
  const [anchorStyle, setAnchorStyle] = useState('anchor-hide');

  useEffect(() => {
    if (isShown) {
      setAnchorStyle(isInApp ? 'anchor-show-mobile' : 'anchor-show-desktop');
    } else {
      setAnchorStyle('anchor-hide');
    }
  }, [isShown]);

  return (
    <div className={anchorStyle}>
      <div className='title-anchor-container layer'>
        <div className='font-header-2 title-anchor-label'>{translate('Heading.RobloxPremium')}</div>
        <GetPremiumButton translate={translate} size={Button.sizes.medium} />
      </div>
    </div>
  );
}

TitleAnchor.propTypes = {
  translate: PropTypes.func.isRequired,
  isShown: PropTypes.bool.isRequired
};

export default TitleAnchor;
